"use strict";

exports.__esModule = true;
exports["default"] = exports.CloseIconWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _utils = require("../../utils");

var _excluded = ["backgroundColor", "textColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** background color string */
  backgroundColor: _propTypes.string,

  /** The React component to display inside the Modal */
  children: _propTypes.string,

  /** Function called when the user clicks the close icon for the Modal */
  closeModal: _propTypes.func.isRequired,

  /** Sets modal to fill the screen at mobile sizes */
  showFullscreenMobile: _propTypes.bool,

  /** text color string */
  textColor: _propTypes.string
};
var modalWrapperStyles = {
  alignItems: "center",
  bottom: 3,
  justifyContent: "center",
  left: 0,
  position: "fixed",
  width: 1,
  zIndex: 10
};
var modalContentStyles = {
  borderRadius: 8,
  boxShadow: "0 2px 10px 0 rgba(74, 90, 117, 0.08), 0 20px 20px -12px rgba(74, 90, 117, 0.24)",
  mx: [2, 3, 160, 236, 331, 432],
  pl: [2, 3],
  position: "relative",
  pr: [5, 64],
  py: 12
};
var closeIconStyles = {
  cursor: "pointer",
  height: 16,
  position: "absolute",
  right: [12, 3],
  top: [12, 2],
  width: 16
};
var textStyles = {
  fontSize: 3,
  letterSpacing: "0.5px",
  lineHeight: 1.5,
  textAlign: "center"
};
var CloseIconWrapper = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "toast-notification__CloseIconWrapper",
  componentId: "sc-1qtvh4x-0"
})([""]);
exports.CloseIconWrapper = CloseIconWrapper;

var ToastNotification = function ToastNotification(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "rgba(50, 83, 220, 0.1)" : _ref$backgroundColor,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? "blue" : _ref$textColor,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var children = props.children,
      closeModal = props.closeModal;
  var close = (0, _utils.useEscapeClose)(closeModal);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, modalWrapperStyles, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    backgroundColor: backgroundColor
  }, modalContentStyles), /*#__PURE__*/_react["default"].createElement(CloseIconWrapper, _extends({
    onClick: close
  }, closeIconStyles), /*#__PURE__*/_react["default"].createElement(_elements.NavClose, {
    color: textColor
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: textColor,
    tag: "p"
  }, textStyles), children)));
};

ToastNotification.propTypes = propTypes;
var _default = ToastNotification;
exports["default"] = _default;